import type { Styles } from 'src/theme/themes';

export const styles = {
  container: {
    flexDirection: 'row',
    gap: 2,
    padding: 0.5,
  },
  rowLabel: (theme) => ({
    width: theme.spacing(23),
    justifyContent: 'center',
  }),
  barContainer: {
    flexGrow: 1,
    height: '4rem',
    flexDirection: 'row',
  },
  bar: {
    borderRightWidth: '2px',
    borderRightStyle: 'solid',
    height: '100%',
    transition: 'all 0.5s ease-out',
    background: `linear-gradient(270deg, rgba(255, 204, 0, 0.10) 88.56%, rgba(255, 244, 199, 0.00) 102.63%)`,
  },
  barLabel: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '-2px',
  },
  barLabelCircle: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    borderWidth: '2px',
    borderStyle: 'solid',
  },
} satisfies Styles;
